import * as fromLoggedInUser from './logged-in-user';
import * as fromNotifications from './notifications';

export interface State {
  loggedInUser: fromLoggedInUser.State;
  notifications: fromNotifications.State;
}
